<template>
<mainTemplateVue :loading="loadingPage">
    <div>
        <md-toolbar :md-elevation="0" class="md-transparent">
            <h3 class="md-title">Adicionar Projeto</h3>
            <md-button class="md-primary" to="/projeto">Voltar</md-button>
        </md-toolbar>

        <v-card class="pa-4 elevation-0">
            <form>
                

                <v-card elevation="0">
                    <v-card-text>
                        <div>
                            <v-chip
                            v-if="form.projeto_id"
                            class="mt-3"
                            :color="form.status['color']"
                            text-color="white"
                            >
                            {{form.status['label']}}
                            </v-chip>
                        </div>
                        

                        <v-row class="mb-3 mt-4">
                            <v-col md="4">
                                <v-autocomplete
                                label="Cliente"
                                v-model="form.cli_id"
                                :items="clientes"
                                :disabled="projetoIsCancelado"
                                required
                                :error-messages="clienteErrors"
                                item-value="cli_id"
                                item-text="cli_nome_fantasia"
                                ></v-autocomplete>
                            </v-col>

                            <v-col md="3">
                                <v-switch
                                v-model="form.projeto_orcamento"
                                :disabled="projetoIsCancelado"
                                label="Orçamento"
                                ></v-switch>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-card elevation="0">
                    <v-card-title>Custos</v-card-title>

                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-text-field
                                label="Custo de Serviços"
                                v-model="form.projeto_custoServico"
                                readonly
                                :disabled="projetoIsCancelado"
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                label="Acréscimo"
                                :disabled="projetoIsCancelado"
                                v-model="form.projeto_acrescimo"
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                v-model="form.projeto_custosExtras"
                                label="Custos Extras"
                                :disabled="projetoIsCancelado"
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                v-model="form.projeto_desconto"
                                label="Desconto"
                                :disabled="projetoIsCancelado"
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                v-model="valorTotal"
                                readonly
                                label="Valor total"
                                :disabled="projetoIsCancelado"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-card elevation="0">
                    <v-card-title>Serviço</v-card-title>

                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-select
                                v-model="form.servico_id"
                                item-text="servicoFullName"
                                item-value="servico_id"
                                :items="servicos"
                                :disabled="projetoIsCancelado"
                                label="Serviço"
                                @change="changeServico"
                                placeholder="Selecione o serviço"
                                clearable
                                ></v-select>
                            </v-col>

                            <v-col>
                                <v-text-field
                                label="Comprimento"
                                v-model="form.projeto_comprimento"
                                placeholder="Insira o comprimento"
                                :required="form.servico_id !== null"
                                :disabled="form.servico_id == null || projetoIsCancelado"
                                :error-messages="comprimentoErrors"
                                ></v-text-field>
                            </v-col>

                            <v-col>
                                <v-text-field
                                label="Largura"
                                v-model="form.projeto_largura"
                                placeholder="Selecione a largura"
                                :required="form.servico_id !== null"
                                :disabled="form.servico_id == null || projetoIsCancelado"
                                :error-messages="larguraErrors"
                                ></v-text-field>
                            </v-col>

                            <v-col>
                                <v-text-field
                                label="Área"
                                v-model="form.projeto_area"
                                disabled
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <v-menu
                                ref="menuProIni"
                                v-model="menus.pro_ini_datepicker"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                        v-model="form.projeto_inicio"
                                        label="Início do Projeto"
                                        required
                                        :disabled="projetoIsCancelado"
                                        :error-messages="inicioErros"
                                        v-bind="attrs"
                                        v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                    v-model="form.projeto_inicio"
                                    @input="menus.pro_ini_datepicker = false"
                                    >
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            
                            <v-col>
                                <v-menu
                                ref="menuProFin"
                                v-model="menus.pro_prev_fin_datepicker"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                        v-model="form.projeto_previsaoTermino"
                                        label="Previsão de Término"
                                        :disabled="projetoIsCancelado"
                                        required
                                        :error-messages="prevTerminoErros"
                                        v-bind="attrs"
                                        v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                    v-model="form.projeto_previsaoTermino"
                                    @input="menus.pro_prev_fin_datepicker = false"
                                    >
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <v-textarea
                                label="Observações"
                                v-model="form.projeto_observacoes"
                                :disabled="projetoIsCancelado"
                                auto-grow
                                value=""
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-card v-if="form.projeto_id" elevation="0">
                    <v-card-title>Anexos</v-card-title>

                    <v-card-text>
                        <v-row>
                            <v-col md="3">
                                <v-text-field
                                required
                                v-model="upload.titulo"
                                placeholder="Título">
                                </v-text-field>
                            </v-col>

                            <v-col md="3">
                                <v-file-input
                                v-model="upload.file"
                                placeholder="Selecione um arquivo"
                                ></v-file-input>
                            </v-col>

                            <v-col md="3">
                                <v-btn large
                                depressed
                                :disabled="upload.titulo.length < 4 || upload.file == null"
                                @click="uploadFile()"
                                color="primary" 
                                class="mt-1">
                                    Anexar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>


                    <v-data-table
                    class="elevation-0"
                    :headers="[
                        {
                            text: 'Título',
                            align: 'start',
                            width: 150,
                            value: 'projetoUpload_titulo'
                        },
                        { 
                            text: '', 
                            value: 'actions', 
                            align: 'center',
                            sortable: false 
                        }
                    ]"
                    :items="uploadedFiles"
                    hide-default-footer
                    >
                        <template v-slot:item.actions="{ item }">
                            <v-btn class="mr-2" icon target="_blank" :href="`https://hdtoldos.com.br/api/${item.projetoUpload_caminho}`">
                                <v-icon>visibility</v-icon>
                            </v-btn>

                            <v-btn icon @click="removeUpload(item.projetoUpload_id)">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card>

                <v-card v-if="form.projeto_id" elevation="0">
                    <v-card-title>Alertas</v-card-title>

                    <v-card-text>
                        <v-btn 
                        outlined
                        @click="formAlerta = true"
                        color="primary">
                        Adicionar alerta
                        </v-btn>
                    </v-card-text>

                    <v-list-item :key="alerta.alerta_id" v-for="alerta in alertas">
                        <v-list-item-content>
                        <v-list-item-title>{{ alerta.alerta_disparo | moment("D/MM/Y")}}</v-list-item-title>
                        <v-list-item-subtitle>{{alerta.alerta_descricao}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-card>


                <v-card class="pa-2 mt-4" elevation="0">
                    <v-btn
                    class="ma-2"
                    color="primary"
                    @click="save()"
                    :disabled="projetoIsCancelado"
                    depressed
                    >
                    {{ form.projeto_id ? "Atualizar Projeto" : "Salvar Projeto" }}
                    </v-btn>

                    <v-btn
                    class="ma-2 white--text"
                    :disabled="projetoIsCancelado || projetoIsOrcamento"
                    @click="form.projeto_finalizado = 1, save()"
                    color="indigo"
                    depressed
                    >
                    Finalizar Projeto
                    </v-btn>

                    <v-btn
                    class="ma-2 white--text"
                    color="error"
                    depressed
                    :disabled="projetoIsCancelado"
                    @click="cancelProjectDialog = true"
                    >
                    Cancelar Projeto
                    </v-btn>

                    <v-btn
                    class="ma-2 white--text"
                    color="primary"
                    @click="downloadOrcamento"
                    depressed
                    :disabled="projetoIsCancelado"
                    >
                    Baixar Orçamento
                    </v-btn>
                </v-card>
            </form>
        </v-card>

        <v-snackbar right v-model="snackbar">
        {{ snackMessage }}
        </v-snackbar>

        <v-dialog
        v-model="cancelProjectDialog"
        max-width="600px"
        >
            <v-card class="pa-5">
                <v-card-text>
                    <v-textarea
                    label="Motivo do cancelamento"
                    v-model="form.projeto_cancelamentoMotivo"
                    auto-grow
                    value=""
                    ></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                    class="white--text"
                    color="error"
                    depressed
                    @click="cancelProject()"
                    >
                    Cancelar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog
        v-model="formAlerta"
        persistent
        max-width="600px"
        >
        <v-card class="pa-4">
            <v-card-title>
            <span class="text-h6">Adicionar nova alerta</span>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col md="12">
                        <v-textarea
                        required
                        v-model="alerta.alerta_descricao"
                        placeholder="Descrição">
                        </v-textarea>
                    </v-col>

                    <v-col md="12">
                        <v-select
                        v-model="alerta.destinatarios"
                        item-value="usu_id"
                        item-text="usu_nome"
                        :items="usuarios"
                        label="Funcionarios"
                        multiple
                        hint="Selecione os funcionários a serem notificados"
                        persistent-hint
                        ></v-select>
                    </v-col>

                    <v-col md="12">
                        <v-menu
                        ref="menuAlertaDate"
                        v-model="menus.pro_alerta_datepicker"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                v-model="alerta.alerta_disparo"
                                label="Data"
                                required
                                v-bind="attrs"
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                            v-model="alerta.alerta_disparo"
                            @input="menus.pro_alerta_datepicker = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                @click="formAlerta = false, alerta.alerta_descricao = '', alerta.destinatarios = [], alerta.alerta_disparo = null"
                text
            >
                Fechar
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="adicionarAlerta()"
                :disabled="alerta.alerta_descricao.length < 4 || alerta.destinatarios.length == 0 || alerta.alerta_disparo == null"
            >
                Salvar
            </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </div>

    
</mainTemplateVue>

</template>

<script>
import mainTemplateVue from '../../../components/main-template.vue'
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import { api } from '../../../services/api'

export default {
    name: 'projeto-form',
    components: {
        mainTemplateVue
    },
    mixins: [validationMixin],
    validations: {
        form: {
            cli_id: {
                required
            },
            projeto_comprimento: {
                required: requiredIf(function() {
                    return this.form.servico_id? true : false
                })
            },
            projeto_largura: {
                required: requiredIf(function() {
                    return this.form.servico_id? true : false
                })
            },
            projeto_inicio: {
                required
            },
            projeto_previsaoTermino: {
                required
            }
        }
    },
    data: () => ({
        snackbar: false,
        snackMessage: '',
        loadingPage: false,
        cancelProjectDialog: false,
        formAlerta: false,
        uploadedFiles: [],
        servicos: [],
        clientes: [],
        alertas: [],
        usuarios: [],
        servico: {
            valor_total: 0,
            valor_total_composicao: null,
            composicao: []
        },
        menus: {
            pro_ini_datepicker: false,
            pro_prev_fin_datepicker: false,
            pro_alerta_datepicker: false
        },
        alerta: {
            alerta_descricao: '',
            alerta_disparo: null,
            destinatarios: []
        },
        upload: {
            titulo: '',
            file: null
        },
        form: {
            projeto_id: null,
            cli_id: null,
            projeto_comprimento: null,
            projeto_custoServico: null,
            servico_id: null,
            projeto_largura: null,
            projeto_area: null,
            projeto_desconto: 0,
            projeto_custosExtras: 0,
            projeto_orcamento: false,
            projeto_cancelado: 0,
            projeto_cancelamentoMotivo: null,
            projeto_acrescimo: 0,
            projeto_pago: false,
            projeto_inicio: null,
            projeto_finalizado: false,
            projeto_dataFinalizado: null,
            projeto_observacoes: null,
            status: {
                label: '',
                color: ''
            },
            projeto_previsaoTermino: null
        },
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: ' #',
          precision: 2,
          masked: false
        }
    }),
    computed: {
        projetoIsOrcamento() {
            return this.form.projeto_orcamento ? true : false
        },
        projetoFinalizado() {
            return this.form.projeto_finalizado ? true : false
        },
        projetoIsCancelado() {
            return this.form.projeto_cancelado ? true : false
        },
        valorTotal(){
            let totalValue = Number(this.servico.valor_total) + Number(this.form.projeto_custosExtras) + Number(this.form.projeto_acrescimo)
            return totalValue - this.form.projeto_desconto
        },
        getProjectStatus(){
            if(this.form.projeto_id) {
                if(this.form.projeto_cancelado) {
                    return {
                        "label": "Projeto Cancelado",
                        "color": "red"
                    }
                } else if(this.form.projeto_orcamento) {
                    return {
                        "label": "Projeto em orçamento",
                        "color": "primary"
                    }
                } else if(this.form.projeto_finalizado) {
                    return {
                        "label": "Projeto Finalizado",
                        "color": "green"
                    }
                } else {
                    if(new Date().getTime() >= new Date(this.form.projeto_inicio).getTime()) {
                        return {
                            "label": "Projeto Iniciado",
                            "color": "primary"
                        }
                    } else {
                        return {
                            "label": "Projeto não iniciado",
                            "color": ""
                        }
                    }
                }
            }

            return null;
        },
        formatDate() {
            console.log(this.$moment(this.form.projeto_inicio).format("d/m/Y"))
            return this.form.projeto_inicio
            ? this.$moment(this.form.projeto_inicio).format("d/m/Y")
            : "";
        },
        clienteErrors () {
            const errors = []
            if (!this.$v.form.cli_id.$dirty) return errors
            !this.$v.form.cli_id.required && errors.push('Você deve selecionar um cliente para continuar')
            return errors
        },

        comprimentoErrors () {
            const errors = []
            if (!this.$v.form.projeto_comprimento.$dirty) return errors
            !this.$v.form.projeto_comprimento.required && errors.push('Você inserir o comprimento')
            return errors
        },
        larguraErrors () {
            const errors = []
            if (!this.$v.form.projeto_largura.$dirty) return errors
            !this.$v.form.projeto_largura.required && errors.push('Você deve inserir a largura')
            return errors
        },
        inicioErros (){
            const errors = []
            if (!this.$v.form.projeto_inicio.$dirty) return errors
            !this.$v.form.projeto_inicio.required && errors.push('Você deve selecionar a data de inicio')
            return errors
        },
        prevTerminoErros (){
            const errors = []
            if (!this.$v.form.projeto_previsaoTermino.$dirty) return errors
            !this.$v.form.projeto_previsaoTermino.required && errors.push('Você deve informar a previsão de término.')
            return errors
        }
    },
    watch: {
        form: {
            handler() {
                this.form.projeto_area = this.form.projeto_comprimento * this.form.projeto_largura
                this.getServicoCoast()

            }, deep: true
        },
    },
    methods: {
        async downloadOrcamento(){
            let res = await api().get(`/projeto/${this.form.projeto_id}/orcamento`, {
                responseType: 'blob'
            })

            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `orcamento-${this.form.projeto_id}.pdf`);
            document.body.appendChild(link);
            link.click();
        },
        async adicionarAlerta(){
            await api().post(`/projeto/${this.form.projeto_id}/alerta`, this.alerta)

            this.formAlerta = false
            this.alerta.alerta_descricao = ''
            this.alerta.alerta_disparo = null
            this.alerta.destinatarios = []

            this.snackbar = true
            this.snackMessage = "Alerta adicionado com sucesso"

            this.getAlerts()
        },
        async removeUpload(id){
            await api().delete(`/projeto/upload/${id}`);
            this.getUploadedFiles()
        },
        async uploadFile(){
            let bodyFormData = new FormData();
            bodyFormData.append('titulo', this.upload.titulo)
            bodyFormData.append('file', this.upload.file)

            await api().post(
                `/projeto/${this.form.projeto_id}/upload`, 
                bodyFormData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            this.upload.titulo = ''
            this.upload.file = null
            
            this.getUploadedFiles()
        },
        async getItem() {
            this.loadingPage = true

            try {
                let res = await api().get(`/projeto/${this.form.projeto_id}`);

                if (!res) {
                    return false;
                }

                this.form = { ...res.data.data };
            } catch (error) {
                return false
            }

            this.loadingPage = false
        },
        async cancelProject(){
            this.form.projeto_cancelado = 1
            this.save().then(() => this.cancelProjectDialog = false)
        },
        async save(){
            this.$v.form.$touch()

            if (!this.$v.form.$invalid) {
                this.loadingPage = true
                let res;

                if (this.form.projeto_id == null) {
                    res = await api().post("/projeto", this.form);
                } else {
                    res = await api().put(`/projeto/${this.form.projeto_id}`, this.form);
                }

                this.loadingPage = false

                if(res) {
                    this.form = res.data.data
                    this.snackbar = true
                    this.snackMessage = "Projeto salvo com sucesso!"
                } else {
                    this.snackbar = true
                    this.snackMessage = "Ocorreu um erro ao salvar o projeto"
                }
            }
        },
        changeServico(e){
            if(e == null){
                this.form.projeto_custoServico = 0
                this.form.projeto_comprimento = null
                this.form.projeto_largura = null
                this.form.projeto_valorTotal = 0
                this.servico = {
                    valor_total: 0,
                    valor_total_composicao: null,
                    composicao: []
                };
            }
        },
        async getServicos() {
            let res = await api().get('servico')
            this.servicos = res.data.data
        },
        async getClientes() {
            let res = await api().get('cliente')
            this.clientes = res.data.data
        },
        async getFuncionarios() {
            let res = await api().get('usuario')
            this.usuarios = res.data.data
        },
        async getUploadedFiles() {
            let res = await api().get(`/projeto/${this.form.projeto_id}/upload`)
            this.uploadedFiles = res.data.data
        },
        async getAlerts() {
            let res = await api().get(`/projeto/${this.form.projeto_id}/alerta`)
            this.alertas = res.data.data
        },
        async getServicoCoast(){
            api().get(`servico/${this.form.servico_id}/custo`, {
                params: {
                    largura: this.form.projeto_largura,
                    comprimento: this.form.projeto_comprimento,
                    area: this.form.projeto_area
                }
            }).then(r => {
                this.servico = r.data.data
                this.form.projeto_custoServico = this.servico.valor_total
            })
        }
    },
    created () {
        this.getServicos();
        this.getClientes();
        this.getFuncionarios()

        if (this.$route.params.id && !isNaN(this.$route.params.id)) {
            this.form.projeto_id = this.$route.params.id
            this.getItem()
            this.getUploadedFiles()
            this.getAlerts()
        }
    }
}
</script>

<style>

</style>